import Paper from "@mui/material/Paper";
import Slide from "@mui/material/Slide";
import Stack from "@mui/material/Stack";
import ThemeContext from "components/app/Context";
import { useContext, useEffect, useState } from "react";
import { useAppSelector } from "redux/hooks";
import "./ScrollAwareHeader.scss";

interface Props {
  children?: any;
  elementId?: string;
}

const ScrollAwareHeader = (props: Props) => {
  const { children, elementId } = props;
  const [show, setShow] = useState(false);
  const { isMobileScreen } = useContext(ThemeContext);
  const isImpersonated = useAppSelector((state: any) => state.app.impersonationDetails.isImpersonated);

  const onScroll = () => {
    const yPos = window.scrollY;
    const yPosition = elementId ? document.getElementById(elementId)?.scrollHeight ?? 80 : 80;

    if (yPos > yPosition) {
      setShow(true);
    } else {
      setShow(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <Slide direction="down" in={show}>
      <Stack
        component={Paper}
        elevation={3}
        spacing={2}
        flexDirection={isMobileScreen ? "column" : "row"}
        alignItems={isMobileScreen ? "flex-start" : "center"}
        className={isImpersonated ? "impersonate-scroll header-scroll " : "non-impersonate-scroll header-scroll"}
      >
        {children}
      </Stack>
    </Slide>
  );
};

export default ScrollAwareHeader;
